import { cn } from "../utils";

type ModalLayoutProps = {
  children: React.ReactNode,
  isActive?: boolean,
  onClose: () => void,
  typeModal: string,
  className?: string
}

const ModalLayout = ({ children, isActive, onClose, typeModal, className }: ModalLayoutProps) => {

  if (!isActive) return null;

  // Para mejorar la experiencia de usuario con esta implementacion logramos cerrar el modal dando click en el exterior
  const handleOnClose = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation()
    if ((e.target as HTMLDivElement).id === "modal-container-" + typeModal) {
      onClose()
    }
  }

  return (
    <div id={`modal-container-${typeModal}`}
      className={cn("fixed inset-0 bg-black bg-opacity-30 z-50 flex justify-center items-center", className)}
      onClick={handleOnClose}
    >
      {children}
    </div>
  )
}

export default ModalLayout